<template>
	<form :class="islightModeActive ? 'bg-documentGray' : ''" novalidate @submit.prevent="sendChat1()">
		<div class="divider-white"></div>
					<div class="comment-section pdt-5 pdb-4 position-relative">
						<div class="d-flex">
						</div>
						<textarea
							id="autoheighttext"
							ref="msg" v-model="msg" :placeholder="$t('1203')" class="mdc-text-field__input t-body6 font-r l-spacing42  mgt-10 mgb-10 pdl-23 pdr-16 t-color-whiteDisabled w-full" maxlength="140" rows="1" ></textarea>
							<div v-show="isAttachments" class="d-flex flex-wrap mgt-24 mgl-16">
								<div v-for="(attachment, index) in attachments" :key="index" class="square-image attached-image-preview with-chat mgb-8">
									<img :src="attachment.resourceUri" alt="image" class="w-48 h-48">
									<span class="remove-img remove-image-new position-absolute t-color-white" tabindex="0" @click="attachments.splice(index, 1)" @keypress="attachments.splice(index, 1)">
                    <i class="material-icons t-body1">close</i></span>
								</div>
							</div>
					</div>
					<div class="chat-bottom-comment-fix">
						<div class="divider-white"></div>
						<div class="d-flex flex-grow-1 justify-content-between pdt-4 pdb-3 align-items-center">
							<button id="btnPhoto" :class="attachments.length <= 0 ? 't-color-whiteDisabled' : islightModeActive ? 't-color-whiteHigh2' : 't-color-whiteHigh'" class="material-icons mdc-icon-button mgl-4" @click="openFileUpload('uploadChatFile')" @keypress="openFileUpload('uploadChatFile')">collections</button>
							<input id="uploadChatFile" ref="imageFiles" :accept="allowImgExt()" class="d-none" type="file" @change="uploadChatFile()" />
							<button :disabled="!isSendBtn" :class="setIconActiveBackground"
								class="mdc-icon-button align-items-center justify-content-between mgr-4" tabindex="0" @click="sendChat()" @kepress="sendChat()">
								<i :class="msg ? 'bg-whiteHigh' : ''" class="t-color-whiteHighLight material-icons min-w-24 min-h-24" style="font-weight:600">arrow_upward</i>
							</button>
						</div>
					</div>
	</form>
</template>

<script>
/**
 * 나의학습/시험 질문하기 - 채팅 등록 컴포넌트(my learn / exam question - chatting write component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import chatApi from '@/api/chatApi.js'
import { fileMixin } from '@/mixins/file.js'
import {MDCRipple} from '@material/ripple'
import microLearnApi from "@/api/microLearnApi";

export default {
	props: ['learnId','lessonId','roomId', 'examineeId', 'questionId', 'islightModeActive'],

	data() {
		return {
			mentionSelector: false,
			msg: '',
			attachments: [],
      isMicroDegree: this.$route.query.micro === true
		}
	},

	mixins: [fileMixin],

	computed: {
		isSendBtn() {        
			return !!this.msg || !!this.attachments.length
		},

		isAttachments() {
			return this.attachments.length
		},

    setIconActiveBackground() {
      if(this.lightModeActive) {
        return this.isSendBtn ? 'sendMessageBtnActive' : 'sendMessageBtn';
      } else {
        return this.isSendBtn ? 'sendMessageLessonBtn' : 'sendMessageBtn';
      }
    }

  },

	mounted() {
		var observe;
		if (window.attachEvent) {
			observe = function (element, event, handler) {
				element.attachEvent('on' + event, handler);
			};
		} else {
			observe = function (element, event, handler) {
				element.addEventListener(event, handler, false);
			};
		}
		function init12() {
			var text = document.getElementById('autoheighttext');
			function resize() {
				text.style.height = 'auto';
				text.style.height = text.scrollHeight + 'px';
			}
			/* 0-timeout to get the already changed text */
			function delayedResize() {
				window.setTimeout(resize, 0);
			}
			observe(text, 'change', resize);
			observe(text, 'cut', delayedResize);
			observe(text, 'paste', delayedResize);
			observe(text, 'drop', delayedResize);
			observe(text, 'keydown', delayedResize);

			text.focus();
			text.select();
			resize();
		}
		init12();
		this.setMaterialUi();
	},

	methods: {
		handleClick() {
			document.getElementById('uploadfile').click()
		},

		onMentionClick(target) {
			this.msg += '@' + target + ' '
			this.mentionSelector = !this.mentionSelector
			this.$refs.msg.focus()
		},
		
		toggleMentionSelector() {
			this.mentionSelector = !this.mentionSelector
		},

		sendChat1() {

		},

		sendChat() {
			if (this.$route.meta.chatType === 'exam') {
				// for exam question
				this.sendExamChat()
			}else {
				// for my learn
				this.sendLearnChat()
			}
		},

		// regist chat for exam
		sendExamChat() {
			let params = {
				examineeId: this.examineeId,
				questionId: this.questionId,
				roomId: this.roomId > 0 ? this.roomId : null,
				msg: this.msg,
				attachments: this.attachments
			}
			
			chatApi.examChatroomChat(params).then((response) => {
				this.msg = ''
				this.attachments = []
				this.$emit('updateListData', response.data.data)
			}).catch((err) => {
				
			})
		},

		sendLearnChat() {
			let params = {
				learnId: this.learnId,
				lessonId: this.lessonId,
				roomId: this.roomId > 0 ? this.roomId : null,
				msg: this.msg,
				attachments: this.attachments
			}

      const FetchAPI = this.isMicroDegree ? microLearnApi.getMicroDegreeChatroomChat : chatApi.learnChatroomChat;
      FetchAPI(params).then((response) => {
				this.msg = ''
				this.attachments = []
				this.$emit('updateListData', response.data.data)
				let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
				let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
				if(goBackBookMarkLessson === 'setVideoBookMarkLesson'){
					localStorage.removeItem('videoBookMarkLesson');
					this.$router.push({
						name: 'BookMarkedLesson' 
					})
				} else if(goBackLikeLessson === 'setVideoLikeLesson'){
					localStorage.removeItem('videoLikeLesson');
					this.$router.push({
						name: 'LikedLesson' 
					})
				} else {
				}
			}).catch((err) => {})
		},

		takeSurvey(id,respondentId,surveyDistributionType){
      let params = {
				distId: id,
				respondentId: respondentId,
			}
			
			this.$router.push({
				name: 'IndependentSurveyIntro',
				params: params,
				query:{status:this.$route.query.status,learnId:this.$router.currentRoute.params.learnId,distributionType:surveyDistributionType}
			})
		},

		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},
	}
}

</script>

<style scoped>

  .sendMessageLessonBtn i {
    background-color: var(--WhiteHigh);
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
  }

</style>
